/**
 * Internal dependencies
 */
import * as actions from './actions';
import { select } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';

export function* getSettings() {
	const query = '/gutenify/v1/get_settings/';
	const settings = yield actions.apiFetch( { path: query } );

	return actions.setSettings( settings );
}

export function* getSiteOptions() {
	const query = '/gutenify/v1/get_site_options/';
	const settings = yield actions.apiFetch( { path: query } );

	return actions.setSiteOptions( {
		settings,
		// styleId: null,
		// globalStyles: {},
		coreSettings: {
			test: 'test',
		},
	} );
}
